import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyflowSortFilterDialogComponent } from './buyflow-sort-filter-dialog.component';
import { BuyflowSortFilterControlModule } from '../../shared/buyflow-sort-filter-control/buyflow-sort-filter-control.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [BuyflowSortFilterDialogComponent],
  imports: [CommonModule, MatButtonModule, BuyflowSortFilterControlModule],
})
export class BuyflowSortFilterDialogModule {}
